import { DOMHelper } from "./helpers/dom-helper";
import { Utils } from "./utils/utils";
import { EventType } from "./constants/event-type-constants";

export interface DataLayer {
    gtmAction: string; // action is "click" when creation was clicked or "display" when was displayed
    gtmLabel: string; // label is CTA parameter obtained from clicked link or clicked creation or displayed creation
    gtmCategory: string; // category (name) of the creation, eg. "zajawka zamkniecia", "ddbox" etc.
}

export class MarketingClientDataLayer {
    protected readonly dataLayer = "dataLayer";
    protected readonly dataset = "dataset";
    protected readonly hrefAttribute = "href";
    protected readonly ctaAttribute = "cta";
    protected readonly ctaCategoryAttribute = "ctaCategory";
    protected readonly ctaContainerAttribute = "[data-cta]";
    protected readonly ctaCategoryContainerAttribute = "[data-cta-category]";
    private readonly paywallEventName = "paywallEvent";

    init() {
        this.bindClickEventToElementsWithDataCtaAttribute();
        this.bindDisplayEventToElementsWithDataCtaAttribute();
    }

    bindClickEventToElementsWithDataCtaAttribute() {
        DOMHelper.querySelectorAsArray(this.ctaContainerAttribute).forEach(ctaContainer => {
            ctaContainer.removeEventListener(EventType.CLICK, (event) => { this.onClick(event) });
            ctaContainer.addEventListener(EventType.CLICK, (event) => { this.onClick(event) }, true);
        });
    }

    bindDisplayEventToElementsWithDataCtaAttribute() {
        DOMHelper.querySelectorAsArray(this.ctaCategoryContainerAttribute).forEach(marketingElement => {
            this.onDisplay(marketingElement);
        });
    }

    onClick(event: any) {
        let clickedElement = event.target as HTMLElement;

        this.pushEventToDataLayer(this.prepareOnClickEventDataToSend(clickedElement));
    }

    prepareOnClickEventDataToSend(clickedElement: HTMLElement): DataLayer {
        let gtmLabel = "", gtmCategory = "";

        if (clickedElement) {
            let clickedElementHref = clickedElement.getAttribute(this.hrefAttribute) || "",
                clickedElementClosestDataCtaCategory = clickedElement.closest(this.ctaCategoryContainerAttribute);

            gtmCategory = clickedElementClosestDataCtaCategory ? clickedElementClosestDataCtaCategory[this.dataset][this.ctaCategoryAttribute] : "";
            gtmLabel = Utils.getURLParamFromEventTarget(clickedElementHref, this.ctaAttribute);

            if (!Utils.stringNotEmpty(gtmLabel)) {
                const clickedElementClosestCta = clickedElement.closest(this.ctaContainerAttribute);
                gtmLabel = (clickedElementClosestCta && clickedElementClosestCta[this.dataset][this.ctaAttribute]) || "";
            }
        }

        return {
            gtmAction: EventType.CLICK,
            gtmLabel,
            gtmCategory
        } as DataLayer;
    }

    onDisplay(element: any) {
        this.pushEventToDataLayer({
            gtmAction: EventType.DISPLAY,
            gtmLabel: element.dataset.cta || "",
            gtmCategory: element.dataset.ctaCategory || ""
        } as DataLayer);
    }

    pushEventToDataLayer(config: object) {
        window[this.dataLayer] = window[this.dataLayer] || [];
        const { gtmCategory, gtmAction, gtmLabel } = <DataLayer>config;

        window[this.dataLayer].push({
            gtmAction,
            gtmLabel,
            gtmCategory,
            "event": this.paywallEventName
        } as DataLayer);
    }
}

export const marketingClientDataLayer = new MarketingClientDataLayer();
